import { Link } from 'react-router-dom';
import { Props } from 'src/features/@types/category';
import { Animate } from 'src/features/global/styles';
import ImageCard from '../imageCard';

// --------------------------------------------------------------------------------------

export default function Category({ title, url, route, disabledAnimate }: Props) {
  return (
    <>
      {disabledAnimate ? (
        <Link to={route} rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
          <ImageCard title={title} url={url} />
        </Link>
      ) : (
        <Animate>
          <Link to={route} rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
            <ImageCard title={title} url={url} />
          </Link>
        </Animate>
      )}
    </>
  );
}
